import React, { Component } from 'react';
import Valid from './validarEndereco';
import api from './../../utilites/api';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Skeleton from '@material-ui/lab/Skeleton';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';


export default class CadEndereco extends Component {

  state = {
    titulo: '',
    end: '',
    colorHeader: "#991e25",
    numero: '',
    bairro: '',
    cep: '',
    obs: '',
    bairros: [],

    idUser: '',
    auth_token: '',
    isLoading: false,
    default_address_id: ''
  }

  async componentDidMount() {
    this.setState({ isLoading: true });

    this.setState({
      idUser: localStorage.getItem('@webApp/userid'),
      auth_token: '',
      endPadrao: ''
    });


    this.getCoordinates();
    this.setState({ isLoading: false });
  }

  handleSubimit = async () => {
    console.log('Resposta: ', 'response.data')
    if (Valid(this.state)) {

      this.setState({ isLoading: true });
      const data = new FormData();
      data.append('nome', this.state.titulo);
      data.append('rua', this.state.end);
      data.append('numero', this.state.numero);
      data.append('bairro', this.state.bairro);
      data.append('complemento', this.state.obs);
      data.append('idUser', this.state.idUser);

      const response = await api.post('ws/CadEndereco.php', data);
      if (response.status === 200) {
        console.log('Resposta: ', response.data)

        this.preecherTab();

      } else {
        alert('Erro na comunicação com servidor!', 'Atenção', false);
        this.setState({ isLoading: false });
      }

    } else {
      alert('Informe todos os dados marcados com ( * )', 'Atenção', false);
      this.setState({ isLoading: false });
    }
  }

  async getCoordinates() {


    try {
      const response = await api.post('ws/ListBairros.php');
      console.log('resposta: ', response.data)
      if (response.status === 200) {
        var tem = [];
        tem = response.data;
        tem.unshift({ "id": "0", "nome": "Selecione seu bairro", "valor": "" });
        if (response.data !== '[]') {
          this.setState({
            bairros: tem
          });
        }
      } else {
        alert('Erro na comunicação com  servidor!', 'Atenção', false);
      }

    } catch (error) {
      console.log('eroo ', error)
      alert('Erro na comunicação com servidor!', 'Atenção', false);
    }

  }

  onValueChange(value) {
    this.setState({
      bairro: value
    });
  }

  async preecherTab() {
    localStorage.setItem('@webApp/enderecoNome', this.state.titulo);
    localStorage.setItem('@webApp/enderecoEnd', this.state.end);
    localStorage.setItem('@webApp/enderecoBairro', this.state.bairro);
    localStorage.setItem('@webApp/enderecoNumero', this.state.numero);

    this.props.history.goBack();
  }

  form() {
    return (
      <div style={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        {this.header()}
        
        {/* Container Principal */}
        <div style={{ 
          maxWidth: '800px', 
          margin: '0 auto', 
          padding: '20px',
          paddingBottom: '100px'
        }}>
          {/* Aviso sobre atendimento */}
          <div style={{
            background: 'linear-gradient(135deg, #fff3cd, #ffeaa7)',
            borderRadius: '12px',
            padding: '16px 20px',
            marginBottom: '24px',
            border: '2px solid #ffc107',
            boxShadow: '0 4px 16px rgba(255, 193, 7, 0.2)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <span style={{ fontSize: '24px' }}>⚠️</span>
              <div>
                <h4 style={{ 
                  margin: '0 0 4px 0', 
                  color: '#856404',
                  fontSize: '16px',
                  fontWeight: '600'
                }}>
                  Atenção!
                </h4>
                <p style={{ 
                  margin: 0, 
                  color: '#856404',
                  fontSize: '14px'
                }}>
                  Verifique se atendemos o seu bairro antes de finalizar o cadastro
                </p>
              </div>
            </div>
          </div>

          {/* Seção de seleção de bairro */}
          <div style={{
            background: '#fff',
            borderRadius: '16px',
            padding: '24px',
            marginBottom: '24px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
            border: '1px solid rgba(0,0,0,0.04)'
          }}>
            <h3 style={{
              margin: '0 0 16px 0',
              fontSize: '20px',
              fontWeight: '700',
              color: '#991e25',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              🏘️ Selecione seu Bairro
            </h3>
            
            <div style={{ marginBottom: '8px' }}>
              <label style={{ 
                fontSize: '14px', 
                fontWeight: '600',
                color: '#555',
                marginBottom: '8px',
                display: 'block'
              }}>
                Bairro <span style={{ color: '#dc3545' }}>*</span>
              </label>
              <Select
                id="demo-simple-select"
                value={this.state.bairro}
                onChange={this.handleChange2}
                style={{ 
                  width: '100%',
                  background: '#fff',
                  borderRadius: '8px'
                }}
                displayEmpty
              >
                {this.state.bairros.map(bairro => (
                  <MenuItem key={bairro.nome} value={bairro.nome}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%'
                    }}>
                      <span>{bairro.nome}</span>
                      {bairro.valor !== '' && (
                        <span style={{
                          background: 'linear-gradient(135deg, #28a745, #20c997)',
                          color: '#fff',
                          padding: '2px 8px',
                          borderRadius: '12px',
                          fontSize: '12px',
                          fontWeight: '600',
                          marginLeft: '8px'
                        }}>
                          R$ {this.mascaraValor(eval(parseFloat(bairro.valor)).toFixed(2))}
                        </span>
                      )}
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>

          {/* Formulário de detalhes do endereço */}
          {this.state.bairro !== '' && this.state.bairro !== 'Selecione seu bairro' && this.restoInf()}
        </div>

        {/* Botão de cadastrar fixo */}
        <div style={{ 
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          right: '20px',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          {this.state.isLoading ? (
            <div style={{
              width: '100%',
              height: '56px',
              background: 'linear-gradient(135deg, #6c757d, #adb5bd)',
              borderRadius: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontSize: '16px',
              fontWeight: '600'
            }}>
              ⏳ Cadastrando...
            </div>
          ) : (
            <Button 
              variant="contained" 
              style={{
                width: '100%',
                height: '56px',
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #28a745, #20c997)',
                boxShadow: '0 8px 24px rgba(40, 167, 69, 0.3)',
                fontSize: '16px',
                fontWeight: '700',
                textTransform: 'none',
                border: 'none',
                color: '#fff'
              }}
              onClick={this.handleSubimit}
            >
              🏠 Cadastrar Endereço
            </Button>
          )}
        </div>
      </div>
    );
  }

  handleChange2 = (event) => {
    this.setState({ bairro: event.target.value });
  }

  restoInf() {
    return (
      <div style={{
        background: '#fff',
        borderRadius: '16px',
        padding: '24px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
        border: '1px solid rgba(0,0,0,0.04)'
      }}>
        <h3 style={{
          margin: '0 0 20px 0',
          fontSize: '20px',
          fontWeight: '700',
          color: '#991e25',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          📝 Detalhes do Endereço
        </h3>

        {/* Nome do endereço */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ 
            fontSize: '14px', 
            fontWeight: '600',
            color: '#555',
            marginBottom: '8px',
            display: 'block'
          }}>
            Nome do endereço <span style={{ color: '#dc3545' }}>*</span>
          </label>
          <Input
            placeholder="Ex: Minha casa, Trabalho, Casa da mãe..."
            value={this.state.titulo}
            disabled={this.state.isLoading}
            style={{ 
              width: "100%",
              padding: '12px 16px',
              fontSize: '16px',
              border: '2px solid #e9ecef',
              borderRadius: '8px',
              backgroundColor: '#fff'
            }}
            name="titulo"
            onChange={this.handleChange}
          />
        </div>

        {/* Endereço (Rua) */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ 
            fontSize: '14px', 
            fontWeight: '600',
            color: '#555',
            marginBottom: '8px',
            display: 'block'
          }}>
            Endereço (Rua) <span style={{ color: '#dc3545' }}>*</span>
          </label>
          <Input
            placeholder="Ex: Rua das Flores, Av. Principal..."
            value={this.state.end}
            disabled={this.state.isLoading}
            style={{ 
              width: "100%",
              padding: '12px 16px',
              fontSize: '16px',
              border: '2px solid #e9ecef',
              borderRadius: '8px',
              backgroundColor: '#fff'
            }}
            name="end"
            onChange={this.handleChange}
          />
        </div>

        {/* Número */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ 
            fontSize: '14px', 
            fontWeight: '600',
            color: '#555',
            marginBottom: '8px',
            display: 'block'
          }}>
            Número <span style={{ color: '#dc3545' }}>*</span>
          </label>
          <Input
            placeholder="Ex: 123, 45A, S/N..."
            value={this.state.numero}
            disabled={this.state.isLoading}
            style={{ 
              width: "100%",
              padding: '12px 16px',
              fontSize: '16px',
              border: '2px solid #e9ecef',
              borderRadius: '8px',
              backgroundColor: '#fff'
            }}
            name="numero"
            onChange={this.handleChange}
          />
        </div>

        {/* Complemento */}
        <div style={{ marginBottom: '0' }}>
          <label style={{ 
            fontSize: '14px', 
            fontWeight: '600',
            color: '#555',
            marginBottom: '8px',
            display: 'block'
          }}>
            Complemento / Ponto de referência
          </label>
          <Input
            placeholder="Ex: Próximo ao mercado, Casa azul, Apto 101..."
            value={this.state.obs}
            disabled={this.state.isLoading}
            style={{ 
              width: "100%",
              padding: '12px 16px',
              fontSize: '16px',
              border: '2px solid #e9ecef',
              borderRadius: '8px',
              backgroundColor: '#fff'
            }}
            name="obs"
            onChange={this.handleChange}
          />
          <small style={{
            fontSize: '12px',
            color: '#6c757d',
            marginTop: '4px',
            display: 'block'
          }}>
            💡 Adicione informações que facilitem a localização
          </small>
        </div>
      </div>
    )
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  header() {
    return (
      <header style={{ 
        background: 'linear-gradient(135deg, #991e25 0%, #b52d36 100%)',
        padding: '16px 20px',
        boxShadow: '0 4px 20px rgba(153, 30, 37, 0.3)',
        borderBottom: '3px solid rgba(255,255,255,0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 1000
      }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <button 
            onClick={() => this.props.history.goBack()}
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '12px',
              padding: '8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(10px)'
            }}
            onMouseEnter={(e) => e.target.style.background = 'rgba(255,255,255,0.25)'}
            onMouseLeave={(e) => e.target.style.background = 'rgba(255,255,255,0.15)'}
          >
            <ArrowBackIcon style={{ color: '#fff', fontSize: 24 }} />
          </button>
          
          <div style={{ marginLeft: 16 }}>
            <h1 style={{ 
              fontSize: 28, 
              fontWeight: 800, 
              margin: 0, 
              color: '#fff',
              letterSpacing: '0.5px',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}>
              🏠 Novo Endereço
            </h1>
            <p style={{
              margin: 0,
              fontSize: '14px',
              color: 'rgba(255,255,255,0.8)',
              fontWeight: '500'
            }}>
              Adicione um novo endereço de entrega
            </p>
          </div>
        </div>
      </header>
    );
  }

  render() {
    return this.form();
  }

  mascaraValor(valor) {
    valor = valor.toString().replace(/\D/g, "");
    valor = valor.toString().replace(/(\d)(\d{8})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{5})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{2})$/, "$1,$2");
    return valor
  }
}